import { styled } from '@mui/material/styles';

export const IconWrapper = styled('div')(() => ({
  width: '100%',
  height: '100%',
  overflow: 'hidden',
  display: 'flex',
}));
